export const MOCK_PACKAGES = [
  {
    "package_id": "pkg_cctv_silver",
    "name": "Silver Plan",
    "description": "Essential CCTV AMC support with monthly hardware checks & camera cleaning",
    "category": "Silver",
    "features": [
      "24-Hour Call Support",
      "Site Visit in 1-2 Days",
      "1 Compulsory Monthly Visit",
      "1 Monthly Camera Cleaning",
      "1 Monthly Hardware Checkup"
    ],
    "price": 299.00,
    "billing_cycle": "monthly",
    "is_popular": false,
    "created_at": "2026-05-26T12:00:00Z"
  },
  {
    "package_id": "pkg_cctv_gold",
    "name": "Gold Plan",
    "description": "Standard CCTV maintenance with weekly on-site services & rapid response",
    "category": "Gold",
    "features": [
      "24-Hour Call Support",
      "Site Visit within 24 Hours",
      "2 Compulsory Monthly Visits",
      "Weekly 1 Day On-Site Service",
      "1 Monthly Full Hardware Check"
    ],
    "price": 599.00,
    "billing_cycle": "monthly",
    "is_popular": true,
    "created_at": "2026-05-26T12:00:00Z"
  },
  {
    "package_id": "pkg_cctv_diamond",
    "name": "Diamond Plan",
    "description": "Premium security support with resident engineer coverage & ultra-fast site visits",
    "category": "Diamond",
    "features": [
      "24-Hour Call Support",
      "Site Visit in 2-4 Hours (Priority)",
      "3 Compulsory Monthly Visits",
      "3 Days / Month Resident Engineer (8Hrs/Day)",
      "2 Monthly Full Hardware Checks"
    ],
    "price": 999.00,
    "billing_cycle": "monthly",
    "is_popular": false,
    "created_at": "2026-05-26T12:00:00Z"
  }
];

export const MOCK_BLOG_POSTS = [
  {
    "post_id": "post_1",
    "title": "Why Your Business Needs an AMC Plan in 2025",
    "slug": "why-business-needs-amc-2025",
    "excerpt": "Discover how Annual Maintenance Contracts can save your business time, money, and headaches.",
    "content": "In today's fast-paced business environment, technology downtime can cost companies thousands of dollars per hour. An Annual Maintenance Contract (AMC) is a critical business strategy that ensures your IT infrastructure remains operational, secure, and up-to-date.\n\nWith a proactive AMC plan, you don't have to wait for something to break before calling support. Our team performs regular health checks, updates security patches, and resolves issues before they impact your operations. This translates to increased productivity, predictable budgeting, and peace of mind.",
    "author": "Tech Team",
    "category": "Business",
    "image_url": "https://images.unsplash.com/photo-1558494949-ef010cbdcc31",
    "published": true,
    "created_at": "2026-05-26T12:00:00Z"
  },
  {
    "post_id": "post_2",
    "title": "Top 5 Network Security Best Practices",
    "slug": "network-security-best-practices",
    "excerpt": "Learn the essential security measures every business should implement.",
    "content": "Network security is no longer optional - it's a business necessity. With cyber threats becoming more sophisticated, businesses of all sizes must take proactive measures to protect their data, networks, and reputation.\n\nHere are the top 5 network security best practices every organization should follow:\n\n1. **Implement Multi-Factor Authentication (MFA)**: MFA adds a layer of protection that makes it significantly harder for unauthorized users to gain access to corporate accounts.\n2. **Regularly Update and Patch Software**: Keep all operating systems, applications, and firmware updated to eliminate known security vulnerabilities.\n3. **Segment Your Network**: Divide your network into smaller, isolated segments to limit the lateral movement of an attacker in the event of a breach.\n4. **Train Employees on Cybersecurity**: The human element is often the weakest link. Educate your team on phishing identification and safe password hygiene.\n5. **Perform Daily Off-Site Backups**: Ensure your data is backed up regularly and stored in a secure, off-site location or cloud storage.",
    "author": "Security Team",
    "category": "Security",
    "image_url": "https://images.unsplash.com/photo-1563986768609-322da13575f3",
    "published": true,
    "created_at": "2026-05-26T11:00:00Z"
  },
  {
    "post_id": "post_3",
    "title": "The Future of CCTV: AI-Powered Surveillance",
    "slug": "future-cctv-ai-surveillance",
    "excerpt": "How artificial intelligence is revolutionizing security camera systems.",
    "content": "Modern CCTV systems are no longer just passive recording devices. The integration of Artificial Intelligence (AI) and Machine Learning (ML) is transforming surveillance cameras into active, smart detectors that can prevent crimes before they happen.\n\nAI-powered surveillance offers several groundbreaking capabilities:\n\n- **Real-Time Object Detection**: Identify and classify people, vehicles, and objects in real-time, reducing false alarms from shadows or animals.\n- **Behavioral Analysis**: Detect suspicious activities, loitering, or sudden movements that indicate potential security threats.\n- **Facial Recognition**: Match faces against white-lists or black-lists to streamline access control or flag unauthorized personnel.\n- **Automated Alerts**: Send instant notifications to security teams or law enforcement when specific rules or triggers are violated.\n- **Smart Analytics**: Analyze traffic flow, occupancy patterns, and foot traffic to optimize business operations.",
    "author": "Security Team",
    "category": "CCTV",
    "image_url": "https://images.unsplash.com/photo-1557597774-9d273605dfa9",
    "published": true,
    "created_at": "2026-05-26T10:00:00Z"
  }
];
